<script lang="ts">
  import { EmptyLabelDefault } from '$provider/constants/global';

  let { value = {} } = $props();
</script>

<div class="comp-simple-address-list-type">
  {#if Object.values(value)?.length !== 0}
    {[
      value?.addressLine1 || '',
      value?.addressLine2 || '',
      value?.city || '',
      value?.state || '',
      value?.zipCode || ''
    ]
      .filter(Boolean)
      .join(', ')}
  {:else}
    {EmptyLabelDefault}
  {/if}
</div>
